import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { func, number, string, object, node, bool } from 'prop-types';
import BaseFormField from './BaseFormField';
import Input from './Input';
import { useValidator } from './useValidator';
export default function TextField(props) {
    const { placeholder, autoComplete, maxLength, tooLongMessage, minLength, tooShortMessage, validate, inputProps, iconBefore, hideCharacterCount = true } = props, otherProps = __rest(props, ["placeholder", "autoComplete", "maxLength", "tooLongMessage", "minLength", "tooShortMessage", "validate", "inputProps", "iconBefore", "hideCharacterCount"]);
    const combinedValidator = useValidator({
        maxLength,
        tooLongMessage,
        minLength,
        tooShortMessage,
        validate,
    });
    const inputPropsToUse = useMemo(() => (Object.assign({ placeholder,
        autoComplete,
        maxLength,
        iconBefore }, inputProps)), [placeholder, autoComplete, maxLength, iconBefore, inputProps]);
    return (React.createElement(BaseFormField, Object.assign({}, otherProps, { hideCharacterCount: hideCharacterCount, validate: combinedValidator, component: Input, inputProps: inputPropsToUse })));
}
TextField.propTypes = {
    /** Input placeholder shown when the field is empty */
    placeholder: string,
    /** Controls autocomplete behaviour (see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) */
    autoComplete: string,
    /** Set maxLength validation for the field */
    maxLength: number,
    /** Validation error message when the field is too long. Required if `maxLength` is set */
    tooLongMessage: string,
    /** Hide character count if maxLength is provided */
    hideCharacterCount: bool,
    /** Sets validation for the minimum length of the field value */
    minLength: number,
    /** Validation error message when the field is too short. Required if `minLength` is set */
    tooShortMessage: string,
    /** Validation function for field-level validation */
    validate: func,
    /** An icon that will be displayed at the start of the input field */
    iconBefore: node,
    /** Extra props to be passed to the Input */
    inputProps: object,
    label: string,
    name: string,
    isSensitive: bool,
    className: string,
};
//# sourceMappingURL=TextField.js.map